<template>
  <b-container class="page-container" fluid>
    <MelaniMethodOfferCheckout />
  </b-container>
</template>
<style>
</style>

<script>
import MelaniMethodOfferCheckout from "@/components/checkout/melanimethodoffer/MelaniMethodOfferCheckout.vue";

export default {
  title: "Melani Method",
  name: "MelaniMethodOffer",
  mounted: function() {
    let optimize = document.createElement("script");
    optimize.setAttribute("src",  "https://www.googleoptimize.com/optimize.js?id=OPT-WDWCDZ9");
    document.head.appendChild(optimize);
  },
  components: {
    MelaniMethodOfferCheckout,
  },
};
</script>
